import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import { generateContentAIAsync, sendMailAsync } from './mail.async'

const initialState = {
  mailLoader: false,
  generateContentAIEmailLoader: false,
  generateContentAIEmail: {},
}

const SendMailReducer = createSlice({
  name: 'SendMailReducer',
  initialState,
  reducers: {
    emptySendMailReducer: (state) => {
      state.generateContentAIEmail = {
        subject: '',
        body: '',
      }
    },
    stopGenerateContentLoader: (state) => {
      state.generateContentAIEmailLoader = false
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(sendMailAsync.pending), (state) => {
      state.mailLoader = true
    })
    builder.addMatcher(isAnyOf(sendMailAsync.fulfilled), (state, action) => {
      state.mailLoader = false
    })
    builder.addMatcher(isAnyOf(sendMailAsync.rejected), (state) => {
      state.mailLoader = false
    })

    builder.addMatcher(isAnyOf(generateContentAIAsync.pending), (state) => {
      state.generateContentAIEmailLoader = true
    })
    builder.addMatcher(isAnyOf(generateContentAIAsync.fulfilled), (state, action) => {
      state.generateContentAIEmailLoader = true
      state.generateContentAIEmail = action.payload.data
    })
    builder.addMatcher(isAnyOf(generateContentAIAsync.rejected), (state) => {
      state.generateContentAIEmailLoader = false
    })
  },
})

export const { emptySendMailReducer, stopGenerateContentLoader } = SendMailReducer.actions
export default SendMailReducer.reducer
